<template>
  <div class="switch-provider-wrapper" v-if="globalData.providers">
    <div class="switch-btn" @click="onShowProviders"></div>
    <div class="switch-provider-modal-wrapper" v-if="isProvidersModalVisible">
      <i class="mask" @click="onHideProviders" />
      <ul class="switch-provider-modal">
        <li
          v-for="provider in globalData.providers"
          :class="['provider-item', provider.active ? 'active' : '']"
          :key="provider.id"
          @click="toProvider(provider)"
        >{{provider.readableName}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { localStorage } from '@/util/index';

export default {
  name: 'SwitchProvider',
  props: {
  },
  data () {
    return {
      isProvidersModalVisible: false,
    };
  },
  methods: {
    onShowProviders: function () {
      this.isProvidersModalVisible = true;
    },
    onHideProviders: function () {
      this.isProvidersModalVisible = false;
    },
    toProvider: function (provider) {
      if (provider.name && !provider.active) {
        localStorage.set('preProvider', provider.name);
        const { href } = window.location;
        window.location.href = `${href.replace('provider=', 'a=')}${href.indexOf('?') > -1 ? '&' : '?'}provider=${provider.name}`;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.switch-provider-wrapper {
  .switch-btn {
    position: fixed;
    bottom: 70px;
    left: 20px;
    width: 30px;
    height: 30px;
    background-image: url('../../assets/dushu/switch.png');
    background-size: contain;
    background-position: center;
    border-radius: 50%;
    box-shadow: 0 0 5px rgba($color: #000, $alpha: 0.5);
    opacity: 0.5;
  }

  .switch-provider-modal-wrapper {
    .mask {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .5);
      z-index: 100;
    }

    .switch-provider-modal {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      background-color: #fff;
      z-index: 101;
      list-style: none;
      margin: 0;
      padding: 10px 20px;
      border-radius: 6px;

      .provider-item {
        width: 60vw;
        border-bottom: 1px solid #aaa;
        text-align: center;
        font-size: 14px;
        line-height: 40px;

        &:last-child {
          border-bottom: 0;
        }

        &.active {
          background-color: #eee;
        }
      }
    }
  }
}
</style>
